import { Component, h, Event, EventEmitter } from '@stencil/core'

@Component({
    tag: 'zr-bannerx-slider-control',
    styleUrl: 'zr-bannerx-slider-control.scss',
    shadow: true,
})

/**
 * ZooRoyal Banner X Slider Controls.
 */
export class ZrBannerxSliderControl {
    /**
     * Handle the click event on the prev button.
     */
    @Event() bannerxPrevClick: EventEmitter

    /**
     * Handle the click event on the next button.
     */
    @Event() bannerxNextClick: EventEmitter

    /**
     * Renders the component.
     */
    render() {
        return (
            <div class="zr-bannerx-slider-control">
                <button
                    aria-controls="bannerx-slider"
                    class="button-prev"
                    type="button"
                    role="button"
                    onClick={this.bannerxPrevClick.emit}
                >Zurück
                </button>
                <button
                    aria-controls="bannerx-slider"
                    class="button-next"
                    type="button"
                    role="button"
                    onClick={this.bannerxNextClick.emit}
                >Weiter
                </button>
            </div>
        )
    }
}
